import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthButtonLinkProps {
  to: string;
  children: ReactNode;
}

/**
 * A link that looks like the primary button.
 *
 * Deliberately not AuthLink wrapping a styled span: text-decoration set on an
 * ancestor is painted through its descendants, so a `no-underline` on the inner
 * element cannot take it back. The rule has to live on the anchor itself.
 */
export const AuthButtonLink = ({ to, children }: AuthButtonLinkProps) => (
  <Link
    to={to}
    className="block w-full rounded-lg bg-auth-action px-4 py-3 text-center text-[13px] font-semibold leading-4 text-auth-action-foreground no-underline hover:opacity-90 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-auth-accent focus-visible:ring-offset-2 focus-visible:ring-offset-auth-card"
  >
    {children}
  </Link>
);
